import { TeilnehmerAntwort } from '@/models/TeilnehmerAntwortModels';
import { BewertungAntwort, UmfrageInfo } from '@/models/UmfrageModels';

export type State = {
  teilnehmerantworten: Array<TeilnehmerAntwort>;
  bewertungantworten: Array<BewertungAntwort>;
  umfrageInfo: UmfrageInfo | null;
};

export const state: State = {
  teilnehmerantworten: sessionStorage.getItem('teilnehmerantworten') != null ? JSON.parse(sessionStorage.teilnehmerantworten) : new Array<TeilnehmerAntwort>(),
  bewertungantworten: sessionStorage.getItem('bewertungantworten') != null ? JSON.parse(sessionStorage.bewertungantworten) : new Array<BewertungAntwort>(),
  umfrageInfo: null,
};
